@if (layout(); as view) {
  <div
    #scroller
    class="scroll"
    tabindex="0"
    role="region"
    [attr.aria-label]="label()"
    [attr.aria-description]="gapsDescription()"
    [style.max-height.px]="view.maxHeight"
    (scroll)="syncScroll()"
  >
    <div
      class="inner"
      [style.width]="view.innerWidth"
    >
      <div
        class="axis"
        [style.grid-template-columns]="view.gridColumns"
      >
        <div class="corner">
          @if (canPage()) {
            <button
              mat-icon-button
              type="button"
              class="page-btn"
              aria-label="Earlier dates"
              title="Earlier dates"
              [disabled]="atStart()"
              (click)="page(-1)"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              class="page-btn"
              aria-label="Later dates"
              title="Later dates"
              [disabled]="atEnd()"
              (click)="page(1)"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          }
        </div>
        @for (week of view.weeks; track week.key) {
          <div
            aria-hidden="true"
            class="week"
            [class.month]="week.month"
            [style.grid-column]="week.column + ' / span ' + week.span"
          >
            {{ week.text }}
          </div>
        }
        @for (gap of view.gaps; track gap.key) {
          <div
            aria-hidden="true"
            class="week gap-label"
            [style.grid-column]="gap.column + ' / span ' + gap.span"
          >
            {{ gap.text }}
          </div>
        }
      </div>

      @if (view.header; as header) {
        <ng-container
          [ngTemplateOutlet]="rowTemplate"
          [ngTemplateOutletContext]="{ $implicit: header, isHeader: true }"
        />
      }
      @for (row of view.rows; track row.row.id) {
        <ng-container
          [ngTemplateOutlet]="rowTemplate"
          [ngTemplateOutletContext]="{ $implicit: row, isHeader: false }"
        />
      }

      <ng-template
        #rowTemplate
        let-row
        let-isHeader="isHeader"
      >
        <div
          class="row"
          [class.header]="isHeader"
          role="group"
          [attr.aria-label]="isHeader ? 'Dates' : row.row.label + (row.row.sub ? ', ' + row.row.sub : '')"
          [style.grid-template-columns]="view.gridColumns"
          [style.grid-template-rows]="'repeat(' + row.lanes + ', minmax(22px, auto))'"
        >
          <div
            class="label"
            [style.grid-row]="'1 / ' + row.rowEnd"
          >
            @if (!isHeader) {
              <span
                class="label-main"
                [title]="row.row.label"
                >{{ row.row.label }}</span
              >
              @if (row.row.sub) {
                <span class="label-sub">{{ row.row.sub }}</span>
              }
            }
          </div>
          @for (weekend of view.weekends; track weekend.key) {
            <div
              class="weekend"
              [style.grid-column]="weekend.column + ' / span ' + weekend.span"
              [style.grid-row]="'1 / ' + row.rowEnd"
            ></div>
          }
          @for (gap of view.gaps; track gap.key) {
            <div
              class="gap"
              [style.grid-column]="gap.column + ' / span ' + gap.span"
              [style.grid-row]="'1 / ' + row.rowEnd"
            ></div>
          }
          @if (!isHeader) {
            @for (guide of view.guides; track guide.id) {
              <div
                class="guide"
                [style.--line-color]="guide.color"
                [style.grid-column]="guide.column"
                [style.grid-row]="'1 / ' + row.rowEnd"
              ></div>
            }
          }
          @if (view.todayColumn; as column) {
            <div
              class="today"
              [style.grid-column]="column"
              [style.grid-row]="'1 / ' + row.rowEnd"
            ></div>
          }
          @for (item of row.items; track item.entry.id) {
            @if (item.bar; as bar) {
              <lib-timeline-bar
                class="bar"
                [bar]="bar"
                [interactive]="false"
                [style.grid-column]="item.column + ' / span ' + item.span"
                [style.grid-row]="item.lane"
                [style.margin-left.px]="bar.continuesLeft ? 0 : item.startHalfPx - 4"
                [style.margin-right.px]="bar.continuesRight ? 0 : item.endHalfPx - 4"
              />
            } @else {
              <div
                class="mark"
                [style.background]="item.entry.color"
                [style.grid-column]="item.column"
                [style.grid-row]="item.lane"
              ></div>
              <span
                class="pill"
                [class.pill-tint]="item.entry.tint"
                [style.--entry-color]="item.entry.color"
                role="img"
                [attr.aria-label]="entryAccessibleName(item.entry)"
                [title]="entryAccessibleName(item.entry)"
                [style.grid-column]="item.column + ' / span ' + item.span"
                [style.grid-row]="item.lane"
                [style.margin-left.px]="item.startHalfPx + 4"
              >
                @if (item.entry.warn) {
                  <svg
                    class="pill-warn"
                    [class.caution]="item.entry.warn === 'warning'"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M12 2 1 21h22L12 2zm1 15h-2v-2h2v2zm0-4h-2V9h2v4z" />
                  </svg>
                }
                <span
                  class="pill-text"
                  aria-hidden="true"
                  >{{ item.text }}</span
                >
              </span>
            }
          }
        </div>
      </ng-template>
    </div>
  </div>
} @else {
  <p class="empty">{{ emptyText() }}</p>
}
